import { FC } from 'react';

const NewBookPage: FC = () => {
    return (
        <>
            <hr />
            <h1>NewBookPage</h1>
            <hr />
        </>
    );
};

export default NewBookPage;
